import { Box, Chip, styled } from '@material-ui/core';

export const ChipsContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
});

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  margin: '4px',
}));

export const DropzoneContainer = styled(Box)(({ theme }) => ({
  border: '2px dashed',
  borderRadius: 8,
  padding: 24,
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: theme.palette.background.default,
  transition: 'all 0.2s ease-in-out',
}));

export const DropzoneWrapper = styled(Box)({
  marginBottom: 4,
  zIndex: 100,
});
